import React from "react";
import Spinner from "react-spinkit";

const Loading = ({ loading }) => {
  return loading ? (
    <div className="overlay-content">
      <div className="wrapper">
            
       <Spinner name="ball-grid-pulse" color="#086CFF"/>
      </div>
    </div>
  ) : null;
};

export default Loading;
